<template>
  <div>
    <!-- header -->
    <Header></Header>
    <!-- <div class="h-16"></div> -->
    <!-- body -->
    <div :class="show ? 'side-bar show' : 'side-bar'">
      <div class="side-button" :class="{ 'side-button--unread-shaking': unreadReminderShaking }">
        <a-button type="primary" @click="showDrawer" class="model-button"
          ><div class="flex flex-col">
            <span class="button-text">在线客服</span>
            <a-icon :type="barvisible ? 'double-right' : 'double-left'" /></div
        ></a-button>
        <span v-if="customerServiceUnread" class="customer-service-unread-badge">{{ customerServiceUnreadLabel }}</span>
      </div>
      <div class="side-right">
        <div class="side-header"
          ><img src="@/assets/images/headset.png" class="w-5 h-5 mr-2 ml-9" />在线客服
          <a-icon type="close" class="ml-7" @click="showDrawer" :style="{ fontSize: '13px' }"
        /></div>
        <div class="flex flex-col items-center justify-items-center">
          <a-button type="primary" class="side-consult-button" @click="openCustomerService(true)">
            在线咨询
            <span v-if="customerServiceUnread" class="side-consult-button__badge">{{ customerServiceUnreadLabel }} 条新回复</span>
          </a-button>
          <p v-if="customerServiceUnread" class="side-consult-unread-tip">您有 {{ customerServiceUnreadLabel }} 条客服回复</p>
          <h6>热线电话</h6>
          <p>13738681177</p>
          <h6>工作时间</h6>
          <p>周一至周五(9:00-17:00)</p>
          <h6>扫一扫联系我们</h6></div
        >
        <div
          ><img
            :src="customerServiceLogoURL"
            :style="{ width: '120px' }"
            class="ml-10"
        /></div>
        <div class="side-foot"
          ><a-icon type="to-top" :style="{ fontSize: '20px' }" @click="toTop"
        /></div>
      </div>
    </div>
    <WebCustomerService
      v-if="customerServiceMounted"
      :visible="customerServiceVisible"
      @minimize="minimizeCustomerService"
      @unread-change="setCustomerServiceUnread"
      @request-open="openCustomerService(false)"
    />
    <div style="min-height: calc(100vh - 276px)">
      <route-view />
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './content/header.vue';
  import Footer from './content/footer.vue';
  import RouteView from './RouteView';
  import WebCustomerService from '@/views/customer-service/index.vue';
  import { config } from '@/api/config';
  import { mapGetters } from 'vuex';
  export default {
    name: 'BasicLayout',
    components: { Header, Footer, RouteView, WebCustomerService },
    data() {
      return {
        collapsed: false,
        menus: [],
        customerServiceMounted: false,
        customerServiceVisible: false,
        customerServiceUnread: 0,
        unreadReminderRounds: 0,
        unreadReminderTimer: null,
        unreadReminderShaking: false,
        barvisible: false,
        show: false,
        originalDocumentTitle: '',
        systemConfig: {},
      };
    },
    computed: {
      contentPaddingLeft() {
        if (!this.fixSidebar || this.isMobile()) {
          return '0';
        }
        if (this.sidebarOpened) {
          return '180px';
        }
        return '80px';
      },
      ...mapGetters(['getToken']),
      customerServiceLogoURL() {
        const base = String(this.systemConfig.public_file_base_url || '').replace(/\/$/, '');
        return base
          ? `${base}/public/system/legacy/static/jdblogo.jpg`
          : 'https://files.jdbsk.com/public/system/legacy/static/jdblogo.jpg';
      },
      customerServiceUnreadLabel() {
        return this.customerServiceUnread > 99 ? '99+' : String(this.customerServiceUnread);
      },
    },
    watch: {
      getToken(value) {
        if (value) this.customerServiceMounted = true;
      },
      '$route.query.online_consult'() {
        this.openCustomerServiceFromRoute();
      },
    },
    created() {},
    beforeDestroy() {
      this.stopUnreadReminder();
    },
    mounted() {
      this.originalDocumentTitle = document.title;
      this.loadSystemConfig();
      if (this.getToken) {
        this.$store.dispatch('user/getUserInfoAction');
        this.customerServiceMounted = true;
      }
      this.openCustomerServiceFromRoute();
    },
    methods: {
      async loadSystemConfig() {
        try {
          this.systemConfig = (await config()) || {};
        } catch (_) {
          // Keep the old public URL available until the new public-file
          // configuration can be read; the customer-service QR must not
          // make the whole website layout fail during a transient request.
          this.systemConfig = {};
        }
      },
      toTop() {
        document.documentElement.scrollTop = 0;
      },
      openCustomerService(requestNotification = false) {
        if (requestNotification) this.requestCustomerServiceNotification();
        this.customerServiceMounted = true;
        this.customerServiceVisible = true;
        this.barvisible = false;
        this.show = false;
      },
      // 浏览器权限只能在真实用户手势中申请。右侧“在线咨询”是官网用户
      // 明确的打开动作，适合作为默认授权入口；拒绝后不重复打扰。
      requestCustomerServiceNotification() {
        if (typeof window === 'undefined' || !('Notification' in window)) return;
        if (window.Notification.permission !== 'default') return;
        window.Notification.requestPermission().catch(() => { /* 浏览器自行处理 */ });
      },
      showDrawer() {
        if (this.barvisible == true) {
          this.barvisible = false;
          this.show = false;
        } else {
          this.barvisible = true;
          this.show = true;
        }
      },
      minimizeCustomerService() {
        this.customerServiceVisible = false;
      },
      setCustomerServiceUnread(count) {
        const previous = this.customerServiceUnread;
        this.customerServiceUnread = Math.max(0, Number(count) || 0);
        if (!this.customerServiceUnread) this.stopUnreadReminder();
        else if (this.customerServiceUnread > previous) this.startUnreadReminder();
        document.title = this.customerServiceUnread
          ? `(${this.customerServiceUnreadLabel}) ${this.originalDocumentTitle}`
          : this.originalDocumentTitle;
      },
      startUnreadReminder() {
        this.stopUnreadReminder();
        this.unreadReminderRounds = 0;
        this.runUnreadReminder();
      },
      runUnreadReminder() {
        if (!this.customerServiceUnread) return;
        this.unreadReminderRounds += 1;
        this.unreadReminderShaking = false;
        this.$nextTick(() => {
          if (!this.customerServiceUnread) return;
          this.unreadReminderShaking = true;
          window.setTimeout(() => { this.unreadReminderShaking = false; }, 800);
        });
        if (this.unreadReminderRounds < 5) {
          this.unreadReminderTimer = window.setTimeout(() => this.runUnreadReminder(), 60000);
        }
      },
      stopUnreadReminder() {
        if (this.unreadReminderTimer) window.clearTimeout(this.unreadReminderTimer);
        this.unreadReminderTimer = null;
        this.unreadReminderRounds = 0;
        this.unreadReminderShaking = false;
      },
      openCustomerServiceFromRoute() {
        if (this.$route.query.online_consult !== '1') return;
        this.openCustomerService();
        const query = { ...this.$route.query };
        delete query.online_consult;
        this.$router.replace({ path: this.$route.path, query });
      },
    },
  };
</script>

<style lang="less">
  .model-button {
    border-color: #415695 !important;
    background-color: #415695 !important;
    height: 120px !important;
    width: 40px !important;
  }
  .side-button {
    position: relative;
    margin-top: 150px;
  }
  .button-text {
    padding-right: 50px;
    font-weight: 700;
    line-height: 21px;
    white-space: normal;
    width: 40px;
    padding-bottom: 2px;
  }
  .button-drawer {
    height: 500px !important;
  }
  .customer-service-unread-badge {
    position: absolute;
    top: -10px;
    left: -10px;
    min-width: 24px;
    height: 24px;
    padding: 0 6px;
    border: 2px solid #fff;
    border-radius: 12px;
    background: #ef5b5b;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    box-shadow: 0 0 0 3px rgba(239, 91, 91, .2);
  }
  .side-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 180px;
    height: 400px;
    border: 1px solid #34478f;
    background: white;
  }
  .side-bar {
    display: flex;
    height: 500px;
    position: fixed;
    z-index: 1000;
    right: -183px;
    top: 35vh;
    transition: right 0.5s;
  }
  .show {
    right: 0px;
  }
  .side-header {
    display: flex;
    align-items: center;
    height: 35px;
    background: #34478f;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }
  .side-foot {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    background: #34478f;
    line-height: 35px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }
  .side-consult-button {
    position: relative;
    width: 120px;
    margin: 8px auto 4px;
    border-color: #415695 !important;
    background: #415695 !important;
  }
  .side-consult-button__badge {
    position: absolute;
    top: -10px;
    right: -28px;
    min-width: 52px;
    height: 20px;
    padding: 0 6px;
    border: 2px solid #fff;
    border-radius: 10px;
    background: #ef5b5b;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    line-height: 16px;
    box-shadow: 0 1px 4px rgba(117, 37, 37, .25);
  }
  .side-consult-unread-tip {
    margin: 0 0 4px;
    color: #d64b4b;
    font-size: 12px;
    font-weight: 600;
  }
  .side-button--unread-shaking .model-button {
    animation: customer-service-unread-shake .8s ease-in-out;
  }
  @keyframes customer-service-unread-shake {
    0%, 100% { transform: translateX(0); }
    16%, 50%, 84% { transform: translateX(-5px); }
    33%, 67% { transform: translateX(5px); }
  }
  @media (max-width: 640px) {
    .side-bar { top: auto; bottom: 122px; }
  }
</style>
